import { apiFetch } from '../apiFetch'

export const getRoles = async () => {
  return await apiFetch({
    path: '/admin/roles'
  })
}

export const getRole = async (slug) => {
  return await apiFetch({
    path: `/admin/roles/${slug}`
  })
}

export const putRole = async (payload) => {
  return await apiFetch({
    method: 'PUT',
    path: `/admin/roles/${payload.slug}`,
    payload
  })
}
